/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RouteAddressService {
  // public noSummaryData = environment.config.companyInfo_icons;
  urlpath = environment.config.prodServerUrl;
  public serverPath = environment.imagePath;
  public imgURL = environment.config.replaceImageUpload;
  public inventoryConvertImage = environment.config.inventoryImagesIcons.inventoryConvert;
  constructor() { }
  summaryDataForInventoryRoute() {
    return this.urlpath + environment.config.inventories.summaryDataInventories;
  }
  getExpiryThresholdOptionsRoute() {
    return this.urlpath + environment.config.businessUnitExpiryThreshold.getExpiryBusinessUnitData;
  }
  updateExpiryProducts() {
    return this.urlpath + environment.config.businessUnitExpiryThreshold.updateExpiryProducts;
  }
  getAddContactRoute() {
    return this.urlpath + environment.config.contacts.addContact;
  }
  locationsRoutes() {
    return this.urlpath + environment.config.location_url.location_info;
  }
  zonesRoutes() {
    return this.urlpath + environment.config.zone_url.zone_info;
  }
  areasRoutes() {
    return this.urlpath + environment.config.area_url.area_info;
  }

  getPersonsBusinessUnit() {
    return this.urlpath + environment.config.attendance.personsBusinessUnit;
  }
  getBusinessUsers() {
    return this.urlpath + environment.config.companyUrl.businessUsersList;
  }
  getPersonData() {
    return this.urlpath + environment.config.attendance.personData;
  }
  getExpiryDataRoute() {
    return this.urlpath + environment.config.expiryItems.expiryData;
  }
  getVehiclesDataRoute() {
    return this.urlpath + environment.config.vehicles.vehiclesList;
  }
  getVehiclesDetailedDataRoute() {
    return this.urlpath + environment.config.vehicles.vehiclesDetails;
  }
  getParticularVehicleTransactionsRoute() {
    return this.urlpath + environment.config.vehicles.vehicleData;
  }
  getUserGroupsRoute() {
    return this.urlpath + environment.config.companyUrl.userGroupsList;
  }
  getTemplateRoute() {
    return this.urlpath + environment.config.user.branches;
  }
  getConfigurationSettings() {
    return this.urlpath + environment.config.companyUrl.configurationURL;
  }
  postReports() {
    return this.urlpath + environment.config.reports.reports;
  }
  getContactsData() {
    return this.urlpath + environment.config.contacts.contacts;
  }
  getContactsSummaryRoute() {
    return this.urlpath + environment.config.contacts.getContactSummary;
  }
  getSpecificContactData() {
    return this.urlpath + environment.config.contacts.businessUnitById;
  }
  getInventoryGroupRoute() {
    return this.urlpath + environment.config.inventory.inventoryGroup;
  }
  getInventoryGroupsInventoryRoute() {
    return this.urlpath + environment.config.inventory.inventoryGroupInventories;
  }
  getItemMasterGroupById() {
    return this.urlpath + environment.config.itemMaster.itemMasterGroupItemMasters;
  }
  getInventoryByCodeRoute() {
    return this.urlpath;
  }
  getInventoryConversionRoute() {
    return this.urlpath + environment.config.inventory.conversions;
  }
  // getBusinessUnitBySearchRoute() {
  //   return this.urlpath + environment.config.businessUnit.search;
  // }
  getCompanyByNameRoute() {
    return this.urlpath + environment.config.contacts.getCompanyByName;
  }
  getInchargingBusinessUnitsRoute() {
    return this.urlpath + environment.config.businessUnit.inchargingUnits;
  }
  getBusinessUnitsByCompanyRoute() {
    return this.urlpath + environment.config.companyUrl.businessUnitsByCompany;
  }
  getBusinessUnitUsersRoute() {
    return this.urlpath + environment.config.businessUnit.businessUnitUsers;
  }
  getContactBusinessUnitRoute() {
    return this.urlpath + environment.config.contacts.getContactBusinessUnit;
  }
  updateItemMasterGroupById() {
    return this.urlpath + environment.config.itemMaster.itemMasterGroupById;
  }
  updateInventoryGroupById() {
    return this.urlpath + environment.config.inventory.inventoryGroupById;
  }
  updateAssignedContactDataRoute() {
    return this.urlpath + environment.config.contacts.updateAssignedContact;
  }
  createChannel() {
    return this.urlpath + environment.config.companyUrl.channel;
  }

  getAllChannels() {
    return this.urlpath + environment.config.companyUrl.allChannels;
  }

  // getInventoryGroupRoute() {
  //   return this.urlpath + environment.config.inventory.inventoryGroup;
  // }
  // getInventoryGroupsInventoryRoute() {
  //   return this.urlpath + environment.config.inventory.inventoryGroupInventories;
  // }
  // getInventoryByCodeRoute() {
  //   return this.urlpath;
  // }
  // getBusinessUnitBySearchRoute() {
  //   return this.urlpath + environment.config.businessUnit.search;
  // }
  // getInchargingBusinessUnitsRoute() {
  //   return this.urlpath + environment.config.inchargingBusinessUnits.inchargingUnits;
  // }

}
